import React from "react";

export const EmptyComponent = () => <></>;
